export default "__VITE_ASSET__de97f7e3__"